import {createAsyncThunk} from '@reduxjs/toolkit';
import Api, {ApiMethods} from '../../../middleware/api';
import {notify} from '../../notifier/services/actions';
import {ProjectInfoDto} from '../../../dto/ProjectInfoDto';
import {FeedbackDto} from '../../../dto/FeedbackDto';
import {ProjectProfiles, ProjectFeedbacks, ProjectGroupedFeedbacks} from '../typedef';

type Args = {
    periodId: number;
    projectId: number;
};

export const getProjects = createAsyncThunk(
    'consolidatedFeedback/getProjects',
    async (_, {dispatch, rejectWithValue, requestId}) => {
        const {httpStatus, responseData} = await Api.fetch({
            endpoint: 'project/consolidated-projects-info',
            method: ApiMethods.GET
        });
        if (httpStatus === 200) {
            return responseData as ProjectInfoDto[];
        }
        dispatch(notify({message: responseData.message, key: requestId, variant: 'error'}));
        return rejectWithValue(responseData);
    }
);

export const getProfiles = createAsyncThunk<ProjectProfiles, number>(
    'consolidatedFeedback/getProfiles',
    async (projectId, {dispatch, rejectWithValue, requestId}) => {
        const {httpStatus, responseData} = await Api.fetch({
            endpoint: `profiles/${projectId}/all-profiles`,
            method: ApiMethods.GET
        });
        if (httpStatus === 200) {
            return {projectId, profiles: responseData};
        }
        dispatch(notify({message: responseData.message, key: requestId, variant: 'error'}));
        return rejectWithValue(responseData);
    }
);

export const getSubmittedFeedbacks = createAsyncThunk<ProjectGroupedFeedbacks, Args>(
    'consolidatedFeedback/getSubmittedFeedbacks',
    async ({periodId, projectId}, {dispatch, rejectWithValue, requestId}) => {
        const {httpStatus, responseData} = await Api.fetch({
            endpoint: `feedback/consolidated/submitted/${projectId}/${periodId}`,
            method: ApiMethods.GET
        });
        if (httpStatus === 200) {
            return {projectId, feedbacks: responseData};
        }
        dispatch(notify({message: responseData.message, key: requestId, variant: 'error'}));
        return rejectWithValue(responseData);
    }
);

export const getConsolidatedFeedbacks = createAsyncThunk<ProjectFeedbacks, Args>(
    'consolidatedFeedback/getConsolidatedFeedbacks',
    async ({periodId, projectId}, {dispatch, rejectWithValue, requestId}) => {
        const {httpStatus, responseData} = await Api.fetch({
            endpoint: `feedback/consolidated/${projectId}/${periodId}`,
            method: ApiMethods.GET
        });
        if (httpStatus === 200) {
            return {projectId, feedbacks: responseData};
        }
        dispatch(notify({message: responseData.message, key: requestId, variant: 'error'}));
        return rejectWithValue(responseData);
    }
);

export const saveConsolidatedFeedback = createAsyncThunk<FeedbackDto, FeedbackDto>(
    'consolidatedFeedback/saveConsolidatedFeedback',
    async (feedback, {dispatch, rejectWithValue, requestId}) => {
        const {httpStatus, responseData} = await Api.fetch({
            endpoint: 'feedback/consolidated',
            method: ApiMethods.POST,
            body: feedback
        });
        if (httpStatus === 201) {
            return responseData;
        }
        dispatch(notify({message: responseData.message, key: requestId, variant: 'error'}));
        return rejectWithValue(responseData);
    }
);
